import Footer from '../layout/Footer/Footer';
import Header from '../layout/Header/Header';
import './ErrorPage.scss';

const ErrorPage = () => {
  return (
    <>
      <Header />
      <div style={{ padding: '1rem 2rem' }}>Error Page</div>
      <Footer />
    </>
  );
};

export default ErrorPage;
